import { useDefaultUnhandledRejectionHandler } from "./useDefaultUnhandledRejectionHandler";

export function DefaultUnhandledRejectionHandler() {
  useDefaultUnhandledRejectionHandler();
  return null;
}
